"use client"

import { LayoutTemplate } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LayoutTemplateIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LayoutTemplateIcon = component(Icon)({ as: LayoutTemplate })
